import { expectsEcho } from './delivery';
export function deliveryVerdict(evidence) {
    if (!evidence.posted)
        return 'failed';
    // 兩個連線都看到同一句，比單一連線的回播更強；這一條就是 UT 的取證路徑。
    if (evidence.echoSeen === true || evidence.peerSeen === true)
        return 'confirmed';
    return evidence.expectsEcho === false ? 'accepted' : 'awaiting';
}
/** 已知站的證據等級；沒登記的站退回 `echo`（跟 ek21 一樣最保守的假設）。 */
export const PLATFORM_PROOF = {
    ek21: { say: 'echo', pm: 'echo' },
    ut: { say: 'peer', pm: 'recipient' },
};
const DEFAULT_PROOF = { say: 'echo', pm: 'echo' };
export function proofPath(service, kind) {
    if (!service)
        return 'echo';
    if (kind !== 'say' && kind !== 'pm')
        return 'none';
    return PLATFORM_PROOF[service]?.[kind] ?? DEFAULT_PROOF[kind];
}
export function retryDecision(input) {
    if (!input.posted)
        return input.attempts < 2 ? 'retry' : 'give-up';
    return input.peerVerifiable ? 'verify-peer' : 'give-up';
}
/** 送出後該不該再抓一次歷史來對帳：只有「站方會回播」的站值得多花一次 GET。 */
export function shouldVerifyByHistory(service, kind) {
    return expectsEcho(service, kind);
}
/** 送出後延後對帳的時間（毫秒）。ek21 回播 7–10 秒，抓太早一定撲空。 */
export const HISTORY_VERIFY_DELAY_MS = 5_000;
/**
 * 在事件串裡找「就是自己剛送出的那句話」。
 *
 * 刻意只比對內容與發話人（不含 `ts`）：站方時間與瀏覽器時鐘一定不同
 * （實測差約 7 秒），用時間比對等於保證找不到。回傳第一個符合的索引，沒有回 -1。
 */
export function findEchoEvent(events, query) {
    return events.findIndex((event) => event.type === query.type &&
        event.from === query.from &&
        event.text === query.text &&
        (event.to ?? '') === (query.to ?? ''));
}
/** 能不能用「重抓歷史比對」補證據；UT 不行——它連歷史都不會回自己的發言。 */
export function canProveByHistory(service, kind) {
    return expectsEcho(service, kind);
}
/** UI 標籤：白話，不出現函式名或端點。 */
export const CONFIRMED_LABEL = '已確認送達';
export const AWAITING_LABEL = '已送出（尚未看到回播）';
/** 由第二個連線證明（UT 的唯一取證路徑）：比「已確認送達」多講一個字——誰看到的。 */
export const PEER_CONFIRMED_LABEL = '已確認送達（第二個帳號看到）';
export const VERIFYING_LABEL = '用第二個帳號確認中…';
/** 按鈕文字：使用者按下去就知道會發生什麼（叫另一個身分去讀訊息）。 */
export const VERIFY_PEER_ACTION = '用第二個帳號確認';
//# sourceMappingURL=delivery-verify.js.map